import * as http from 'utils/http';
import config from 'config';
import serialize from 'utils/serialize';

const getPrebookingForecast = (filters) => {
  const { route, date } = filters;

  if (!route || !date) {
    return new Promise((_, reject) => {
      reject('Route and date needed to call the service');
    });
  }

  const params = serialize({
    date,
    route: `${route}->${route}`,
  });

  return http.get(`${config.API_URL}prebookings/forecast/?${params}`);
};

export default getPrebookingForecast;
